import { AxiosInstance } from 'axios';
import {
  IFetchTicketsParams,
  IFetchTicketsResponse,
  TFetchOneTicketResponse,
  IUpdateTicketParams,
  TUpdateTicketResponse,
  IReplyToTicketParams,
  TReplyToTicketResponse,
  IAttachFileToMessageParams,
  TAttachFileToMessageResponse,
  TFetchCategoriesResponse,
  ICreateTicketParams,
  TCreateTicketResponse,
  TMarkMessagesAsRead,
  IFetchUnreadTicketsMessagesResponse,
  IFetchOneTicketParams,
} from '@sv-support-sdk/shared-types/src/api/tickets'

export default (api: AxiosInstance) => ({
  fetchTickets: (params: IFetchTicketsParams): Promise<IFetchTicketsResponse> =>
    api.get('/ticket', { params }),
  fetchOneTicket: (ticketId: string, params: IFetchOneTicketParams): Promise<TFetchOneTicketResponse> =>
    api.get(`/ticket/${ticketId}`, { params }),
  updateTicket: (
    ticketId: string,
    params: { hash: string },
    body: IUpdateTicketParams,
  ): Promise<TUpdateTicketResponse> => api.put(`/ticket/${ticketId}`, body, { params }),
  replyToTicket: (
    ticketId: string,
    params: { hash: string },
    body: IReplyToTicketParams,
  ): Promise<TReplyToTicketResponse> => api.post(`/ticket/${ticketId}/message`, body, { params }),
  saveAttachment: (body: IAttachFileToMessageParams): Promise<TAttachFileToMessageResponse> =>
    api.post(`/ticket/attachment`, body),
  fetchCategories: (): Promise<TFetchCategoriesResponse> => api.get(`/request-category/list`),
  createTicket: (body: ICreateTicketParams): Promise<TCreateTicketResponse> =>
    api.post(`/ticket`, body),
  fetchUnreadTicketsMessages: (): Promise<IFetchUnreadTicketsMessagesResponse> =>
    api.get(`/unread`),
  markMessagesAsRead: (
    ticketId: number,
    params: { hash: string },
    body: { read: number },
  ): Promise<TMarkMessagesAsRead> => api.put(`ticket/${ticketId}`, body, { params }),
});
